angular.module("UI8.components").component("hasDnaFilter", {
  template:
    "<button class='filters__toggle' ng-class='{ active: $ctrl.hasDesignDna }' ng-click='$ctrl.toggleHasDesignDna()' on-load='$ctrl.changeHandler()'>AI-Ready</button>",

  controller: function () {
    var ctrl = this;
    var slug;

    ctrl.changeHandler = function () {
      slug = location.pathname.split("/").pop();
      var storedFilter = sessionStorage.getItem(
        slug + ":category-has-dna-filter"
      );
      setHasDesignDna(storedFilter === "true");

      document.body.addEventListener("reset-category-filters", resetListener);
    };

    ctrl.$onDestroy = function () {
      document.body.removeEventListener(
        "reset-category-filters",
        resetListener
      );
    };

    ctrl.toggleHasDesignDna = function () {
      ctrl.hasDesignDna = !ctrl.hasDesignDna;
      applyUpdate();
    };

    function setHasDesignDna(hasDesignDna) {
      ctrl.hasDesignDna = hasDesignDna;
      applyUpdate();
    }

    function applyUpdate() {
      sessionStorage.setItem(slug + ":category-has-dna-filter", ctrl.hasDesignDna);
      ctrl.onUpdate({ value: ctrl.hasDesignDna });

      var header = $(".header"),
        trigger = $(".page__trigger"),
        filters = $(".page__filters--sticky");

      if (filters.hasClass("scrolled"))
        window.scroll(0, trigger.offset().top - header.outerHeight());
    }

    function resetListener() {
      if (ctrl.hasDesignDna) ctrl.toggleHasDesignDna();
    }
  },

  bindings: {
    onUpdate: "&",
  },
});
